<div class="modal-header">
    <h2 class="modal-title" translate>lblSearchLabor</h2>
    <button type="button" class="close" aria-label="Close" (click)="OnClose()">
        <span aria-hidden="true">×</span>
    </button>
</div>
<div class="modal-body p-0 min-h500">
    <div class="popup-vcenter">
        <div class="card pad15">
            <div class="form-row">
                <div class="col-2">
                    <label for="template-make" translate>lblMake</label>
                    <div class='lbl-info'>
                        <ng-select placeholder="{{ 'lblSelectMake' | translate }}" [(ngModel)]="brandCode">
                            <ng-option *ngFor="let type of makeList" [value]="type.brandCode">
                                {{type.brandCode}}</ng-option>
                        </ng-select>
                    </div>
                </div>
                <div class="col-2">
                    <label for="service" translate>lblLaborNumber
                        <strong class="mlt6 required"> * </strong>
                    </label>
                    <div class='lbl-info'>
                        <input class="form-control mb-2" [(ngModel)]="laborNumber" (keyup.enter)="onSearchLabor()"
                            placeholder="{{ 'lblLaborNumber' | translate }}" maxlength="20">
                    </div>
                </div>
                <div class="col-2">
                    <label for="service" translate>lblLaborName
                        <strong class="mlt6 required"> * </strong>
                    </label>
                    <div class='lbl-info'>
                        <input class="form-control mb-2" [(ngModel)]="laborName"
                            placeholder="{{ 'lblLaborName' | translate }}" maxlength="50" (keyup.enter)="onSearchLabor()">
                    </div>
                </div>
                <div class="col-auto">
                    <button class="btn btn-primary mt-22" type="button" (click)="onSearchLabor()">
                        <em class="fa fa-search"></em> Search
                    </button>
                </div>
            </div>
        </div>
        <div class="pad15">
            <div class="card">
            <div class="table-responsive partlabor-scroll" >
                <table class="tablest1">
                    <thead>
                        <tr>
                            <th scope="col" style="width: 20px" class="pl-1" translate></th>
                            <th scope="col" translate>lblMake</th>
                            <th scope="col" translate>lblLaborNumber</th>
                            <th scope="col" translate>lblLaborName</th>
                            <th scope="col" style="width:100px" translate>lblDuration <span>(Hrs)</span>
                            </th>
                            <th scope="col" class="text-right" translate>lblPrice</th>
                        </tr>
                    </thead>
                    <tbody >
                        <ng-container *ngIf="laborList?.length>0; else load_NotFound_Template">
                            <ng-container *ngFor="let labor of laborList; let i=index">
                                <tr>
                                    <td>
                                        <div class="form-check p-1">
                                            <input type="checkbox" [(ngModel)]="labor.isLaborSelected"
                                                [checked]="labor.isLaborSelected" />
                                        </div>
                                    </td>
                                    <td>
                                        <ngb-highlight [result]="labor.makeCode">
                                        </ngb-highlight>
                                    </td>
                                    <td>
                                        <ngb-highlight [result]="labor.laborNo">
                                        </ngb-highlight>
                                    </td>
                                    <td>
                                        <ngb-highlight [innerHTML]="labor.name">
                                        </ngb-highlight>
                                    </td>
                                    <td>
                                        <input type="text"
                                            class="form-control customize-textbox text-right"
                                            [value]="labor.duration" [(ngModel)]="labor.duration"
                                            maxlength="5"
                                            (keypress)="isQtyPrice($event,labor.duration)" />
                                    </td>
                                    <td class="text-right">
                                        <ngb-highlight [result]="labor.fixedPrice |number: '1.2-2'">
                                        </ngb-highlight>
                                    </td>
                                </tr>
                            </ng-container>
                        </ng-container>

                        <ng-template #load_NotFound_Template>
                            <tr>
                                <td colspan="8" class="no-record" translate>lblChangeSearchCriteria</td>
                            </tr>
                        </ng-template>
                    </tbody>
                 
                </table>
            </div>
        </div>
        </div>
       
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-primary" aria-label="Center Align" (click)="onSaveItems()"
        translate>lblAdd</button>
    <button type="button" class="btn btn-secondary" (click)="OnClose()" aria-label="Center Align"
        translate>lblClose</button>
</div>